import { render, staticRenderFns } from "./ReelsTable.vue?vue&type=template&id=5df8ee2a&"
import script from "./ReelsTable.vue?vue&type=script&lang=js&"
export * from "./ReelsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReelsTable.vue?vue&type=style&index=0&id=5df8ee2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports